import clsx from 'clsx';
import { useAppointmentSchedulerStore } from '../../stores/appointment-scheduler-store';

export function BypassPostcodegebiedCard() {
  const isOpen = useAppointmentSchedulerStore((s) => s.bypassConfirmOpen);
  const reden = useAppointmentSchedulerStore((s) => s.bypassReden);
  const error = useAppointmentSchedulerStore((s) => s.bypassError);
  const isLoadingRoutes = useAppointmentSchedulerStore((s) => s.isLoadingRoutes);
  const setReden = useAppointmentSchedulerStore((s) => s.setBypassReden);
  const confirm = useAppointmentSchedulerStore((s) => s.confirmBypass);
  const close = useAppointmentSchedulerStore((s) => s.closeBypassConfirm);

  if (!isOpen) return null;

  const canSubmit = !isLoadingRoutes && reden.trim().length >= 3;

  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 p-4 space-y-3">
      <div className="flex items-start justify-between">
        <div>
          <h3 className="text-sm font-semibold text-amber-900">Andere route kiezen</h3>
          <p className="text-xs text-amber-800 mt-0.5">
            Plan deze order bij een route buiten het normale postcodegebied. Reden wordt
            vastgelegd op de order voor audit.
          </p>
        </div>
        <button
          type="button"
          onClick={close}
          className="text-xs text-amber-800 hover:underline"
        >
          Annuleren
        </button>
      </div>

      <div className="space-y-2">
        <label className="text-xs font-medium text-amber-900 block">
          Reden <span className="text-amber-700">(verplicht, min. 3 tekens)</span>
        </label>
        <textarea
          value={reden}
          onChange={(e) => setReden(e.target.value)}
          placeholder="Bijv. spoedklant Spijkenisse, Rotterdam past beter qua tijd..."
          rows={2}
          className="w-full px-3 py-2 text-sm border border-amber-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-amber-500 resize-none"
        />
      </div>

      <p className="text-[11px] text-amber-800">
        Buiten dienstgebied wordt zichtbaar gemarkeerd op de order en gelogd met je e-mailadres.
      </p>

      {error && (
        <div className="px-3 py-2 bg-red-50 border border-red-200 rounded-md text-xs text-red-700">
          {error}
        </div>
      )}

      <button
        type="button"
        onClick={confirm}
        disabled={!canSubmit}
        className={clsx(
          'w-full px-4 py-2.5 text-sm font-medium rounded-md transition-colors',
          canSubmit
            ? 'bg-amber-600 text-white hover:bg-amber-700'
            : 'bg-slate-200 text-slate-400 cursor-not-allowed'
        )}
      >
        {isLoadingRoutes ? 'Routes laden…' : 'Bevestig — toon alle routes'}
      </button>
    </div>
  );
}
